import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push, set, get, onValue, update } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyC_96heDbUCe-5gBCw9tLkCj49Th4v9Yd4",
  authDomain: "dashy-tet.firebaseapp.com",
  databaseURL: "https://dashy-tet-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dashy-tet",
  storageBucket: "dashy-tet.firebasestorage.app",
  messagingSenderId: "572493475258",
  appId: "1:572493475258:web:f840491147fa845a9b8183"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export { ref, push, set, get, onValue, update };
export default app;
